import { AgentChat as PackageAgentChat } from "@repo/agent-chat";
import { AgentChatExpandButton } from "./expand-button";
import { AgentChatRoot } from "./root";

/**
 * Compound API for the in-app AI assistant chat. Compose freely inside any container.
 *
 * MIN-293: every connected part (`Thread`, `PromptInput`, `Submit`, `Turn`,
 * `Header` + its buttons) now lives in `@repo/agent-chat`; this app declares
 * only what stays app-side — `Root` (the thin wrapper owning the store's
 * auto-pick-most-recent policy) and `ExpandButton` (router-dependent,
 * MIN-263 decision #5).
 *
 * @example
 * <AgentChat.Root>
 *   <AgentChat.NewChatButton />
 *   <AgentChat.Thread />
 *   <AgentChat.PromptInput />
 * </AgentChat.Root>
 */
export const AgentChat = {
  ...PackageAgentChat,
  Root: AgentChatRoot,
  ExpandButton: AgentChatExpandButton,
};

export type { AgentChatContextValue } from "./context";
export { useAgentChatContext } from "./use-agent-chat-context";
